/* global $:false */

import Rails from '@rails/ujs'
import Site from 'src/public/site.js'

import MarketLotShowSidebar from 'src/public/market_lot_show_sidebar.js'
import SidebarContentBlockSlugs from 'src/public/sidebar_content_block_slugs.js'
import ContactInfos from 'src/public/contact_infos.js'
import ShoppingCart from 'src/public/shopping_cart.js'
import ShoppingCartDropdown from 'src/public/shopping_cart_dropdown.js'
import FacebookShare from 'src/public/facebook_share.js'
import TopbarContentBlockSlugs from 'src/public/topbar_content_block_slugs.js'
import Boost from 'src/public/boost.js'
import AppBoost from 'src/public/app_boost.js'
import LiveBanner from 'src/public/live/live_banner.js'

Rails.start()

const boost = new Boost(Site.init)

$(() => {
  boost.start(window.gon.git_revision)
  const appBoost = new AppBoost()
  appBoost.start()
  LiveBanner.init()
  Site.init()
})

// These are all accessible through the global variable Bukowskis and
// available like so: new Bukowskis.ShoppingCart(). Everything not
// explicitly exported is a blackbox to the site.

export {
  MarketLotShowSidebar,
  SidebarContentBlockSlugs,
  ContactInfos,
  ShoppingCart,
  ShoppingCartDropdown,
  FacebookShare,
  TopbarContentBlockSlugs
}
